export default __webpack_public_path__ + "static/sc-enrichment-datatag-7e2c55cdf1a76c8bb409679b4013e661.mp4";